module.exports = __webpack_public_path__ + "static/media/pg03.597c4d8c.jpg";